<template>
  <div class="email">
    <template v-if="visitableSliderNav">
      <div :class="[!isClose?'SideTab':'SideTab_sp','scroll']" ref="SideTab">
        <div
            class="opt fx pointer rlt"
            :class="{ s: i === tabIndex }"
            v-for="(o, i) in teamList"
            :key="i"
            @click="tabChange(i, o)"
            :style="{
            backgroundColor: !isEnterpriseChildUser? i === tabIndex ? 'var(--el-color-danger)' : '#fff':i === tabIndex ? 'rgb(62, 141, 87)' : '#fff',
          }"
        >
          <div :class="['fx-aj-c','flex1' ,!isClose?'tab_item':'tab_item_sp']" ref="teamFlag">
            <div class="tab_name" :title="o.name">{{ o.name }}</div>
          </div>
          <div
              class="ic"
              v-if="i !== tabIndex"
              :style="{ backgroundColor:!isEnterpriseChildUser? 'var(--el-color-danger)':'rgb(62, 141, 87)', width: '4px' }"
          ></div>
        </div>
        <div
            ref="addTeam"
            v-if="!isEnterpriseChildUser"
            class="opt fx-aj-c pointer"
            :class="[tabIndex === 'add'?'s':'',!isClose?'show':'hide' ]"
            @click="tabChange('add', { teamID: teamId })"
        >
          <img class="add" src="@/assets/img/tab/add.png"/>
        </div>
      </div>
      <!--      SideBar-->
      <SideBar v-if="Boolean(shouldShowSideBar)" @clickSide="handleClickSide"/>
    </template>
    <!--  展示 -->
    <div class="view" id="view_callog">
      <!--      内部内容-->
      <router-view v-if="isRouterAlive"></router-view>
    </div>
    <!--    -->
    <CreateTeamPop v-if="visitable" v-model="visitable" @close="close" @update:tabIndex="changeTabIndex"/>
    <!--    工位预警-->
    <PositionWarningPop v-if="dialogVisibleTips" v-model="dialogVisibleTips"
                        @close="closePositionDia"></PositionWarningPop>
    <!--    邮箱是否绑定？-->
    <Dialog
        v-model="dialogVisibleEmailBind"
        :width="400"
        :title="$t('sys.team.info')"
        :dialogVisible="dialogVisibleEmailBind"
        :isHeadLine="false"
        @cancel="cancelConfig"
        @update:dialogVisible="(val) => (dialogVisibleEmailBind = val)"
    >
      <template #content>
        <div class="cont">
          <span class="text">{{ isFirstShow ? $t('create.team.tip') : $t('common.email.reminderEmailAddress') }}</span>
        </div>
      </template>
      <template #footer>
        <div class="setting_left">
          <el-button size="small" @click="cancelConfig">{{ $t('common.sss16') }}</el-button>
          <el-button size="small" type="primary" @click="goToAddShowConfig">{{ $t('common.confirm') }}</el-button>
        </div>
      </template>
    </Dialog>
  </div>
</template>

<script>
import {computed, nextTick, onBeforeUpdate, onMounted, onUpdated, ref, watch} from "vue";
import {useStore} from "vuex";
import CreateTeamPop from "../components/DiaPops/CreateTeamPop.vue";
import SideBar from "./SideBar/SideBar.vue";
import {useRouter, useRoute} from "vue-router";
import Dialog from "@/components/Dialog.vue";
import '@/views/components/css/index.css'
import _store from "store2";
import {getMailConfigList} from "@/api";
import PositionWarningPop from "@/components/DiaPops/PositionWarningPop.vue";
import sidebar from "@/store/modules/sidebar";
import {Expand, Fold} from "@element-plus/icons-vue";
import sessionStore from "@/utils/sessionStore";
import {ensureSeatAvailable} from "@/utils/resourceGuard";

export default {
  components: {Fold, Expand, PositionWarningPop, Dialog, CreateTeamPop, SideBar},
  setup() {
    const router = useRouter();
    const route = useRoute();
    const store = useStore();
    const teamList = computed(() => store.state.email.teamList);
    const saved = sessionStore.get('tabIndex')
    const tabIndex = ref(saved === null || saved === undefined ? 0 : saved)

    const getTabIndex = computed(() => {
      let indexs = [];
      if (route.query.teamID) {
        store.commit('email/setCurTeamID', String(route.query.teamID))
        const result = teamList.value.filter(item => item.id === route.query.teamID)
        indexs = result.map(item => teamList.value.indexOf(item));
      }
      return route.query.teamID ? indexs[0] : sessionStore.get('tabIndex') === null ? 0 : sessionStore.get('tabIndex') * 1
    })

    const visitable = ref(false);
    const isEnterpriseChildUser = computed(
        () => store.getters["user/isEnterpriseChildUser"]
    );
    const visitableSliderNav = computed(
        () => route.path !== '/email/write_mail' && route.path !== '/email/send_all' && !route.path.includes('/email/detail')
    );
    const mailWorkPosition = computed(() => store.state.user.mailWorkPosition)
    const dialogVisibleTips = ref(false)
    const teamId = computed(() => store.state.email.teamID)
    const userInfo = computed(() => store.state.user.userInfo);

    const dialogVisibleEmailBind = ref(false)
    const isRouterAlive = computed(() => store.state.sidebar.isRouterAlive)

    const shouldShowSideBar = computed(() => store.state.email.shouldShowSideBar)

    const syncShouldShowSideBar = () => {
      if (!Array.isArray(teamList.value) || teamList.value.length === 0) return

      // 以 route.query.teamID/teamId > store.teamId > sessionStore.teamId 为准
      const curTeamIdRaw = route.query.teamID || route.query.teamId || teamId.value || sessionStore.get('teamId');
      const curTeamId = curTeamIdRaw === null || curTeamIdRaw === undefined ? '' : String(curTeamIdRaw);
      const curTeam = teamList.value?.find(t => String(t?.id) === curTeamId);

      // 拿不到团队信息时，默认展示（避免刷新时出现 null 导致的误隐藏）
      if (!curTeam) {
        store.commit("email/setShouldShowSideBar", true);
        return;
      }

      const expireMs = curTeam.expireTime ? new Date(curTeam.expireTime).getTime() : null;
      const shouldShow = expireMs === null || expireMs > Date.now();
      store.commit("email/setShouldShowSideBar", shouldShow);

      const targetRoute = shouldShow
        ? '/email/inbox'
        : `/email/systemPrompt?teamId=${curTeam.id}&workPositionId=${curTeam.workPositionId}`

      if (!route.path.startsWith('/email')) return
      if (route.fullPath === targetRoute) return

      // systemPrompt <-> inbox 自动校正（切换账号后默认团队可能已过期）
      if (!shouldShow && !route.path.startsWith('/email/systemPrompt')) {
        router.replace(targetRoute).catch(() => {})
      }
      if (shouldShow && route.path.startsWith('/email/systemPrompt')) {
        router.replace(targetRoute).catch(() => {})
      }
    }

    async function tabChange(index, item) {
      console.log(index, item, 'tabChange');

      // -------------------------------
      // ① Add Tab 特殊逻辑
      // -------------------------------
      if (index === "add") {
        const hasSeat = await ensureSeatAvailable(store)
        if (hasSeat) {
          visitable.value = true;
        } else {
          dialogVisibleTips.value = true;
        }
        return;
      }

      // -------------------------------
      // ② 记录 tab index
      // -------------------------------
      tabIndex.value = index;
      sessionStore.set('tabIndex', index);

      // -------------------------------
      // ③ 设置团队 ID (commit 不需要 await)
      // -------------------------------
      await store.commit("email/setCurTeamID", item.id);

      // -------------------------------
      // ④ 计算跳转路由
      // -------------------------------
      const targetRoute = computeEmailRoute(item);

      // -------------------------------
      // ⑤ 避免多次跳转，把路由 push 放在这里统一处理
      // -------------------------------
      try {
        if (targetRoute) {
          await router.push(targetRoute);
        }
      } catch (e) {
        console.warn("Navigation warning: ", e);
      }

      // 如果跳转的是 systemPrompt，后续逻辑无需执行
      if (targetRoute.startsWith('/email/systemPrompt')) {
        return;
      }

      // -------------------------------
      // ⑥ 判断是否绑定邮箱
      // -------------------------------
      await getList();
      if (emailList.value.length === 0) {
        dialogVisibleEmailBind.value = true;
      }

      // -------------------------------
      // ⑦ 清除缓存
      // -------------------------------
      // sessionStore.clear();

      // -------------------------------
      // ⑧ 刷新权限与文件信息
      // -------------------------------
      try {
        await store.dispatch("user/checkUserInfoIsAdmin", {
          teamId: teamId.value,
        });

        await refreshSidebarFiles(teamId.value);

      } catch (err) {
        console.error("刷新权限或文件信息失败:", err);
      }
    }

    function computeEmailRoute(item) {
      const expire = item.expireTime ? new Date(item.expireTime).getTime() : null;
      console.log(expire, 'expire')
      if (expire === null || expire > Date.now()) {
        // 永久有效 or 未过期
        store.commit("email/setShouldShowSideBar", true);
        return '/email/inbox';
      }

      // 已过期
      store.commit("email/setShouldShowSideBar", false);
      return `/email/systemPrompt?teamId=${item.id}&workPositionId=${item.workPositionId}`;
    }

    async function refreshSidebarFiles(teamId) {
      await store.dispatch("sidebar/getEmailGroupFileAllList", {teamId, userId: userInfo.value.id});
      store.commit("sidebar/setTargetFileList", []);
      store.commit("sidebar/setPageSetting", {type: 'pageNo', value: 1});

      await store.dispatch("sidebar/getEmailGroupFileListApis", {
        teamId,
        userId: userInfo.value.id,
        isUpdateFileList: true,
      });
    }

    async function close() {
      visitable.value = false;
      // 判断是否绑定了邮箱，如果绑定了不进行弹窗
      await getList()

      if (emailList.value.length === 0) {
        //  弹窗 是否需要绑定
        dialogVisibleEmailBind.value = true;
      }
    }

    const closePositionDia = () => {
      dialogVisibleTips.value = false
    }


    function toBuy() {
      dialogVisibleTips.value = false
    }


    //  获取邮箱列表
    const tableData = ref([])
    const emailList = ref([])

    async function getList() {
      // console.log("用户信息ddd", _store.get("userInfo"), teamId.value);
      // 从 缓存中拿
      // const teamId = window.localStorage.getItem("teamId")
      await getMailConfigList({teamId: teamId.value})
          .then((res) => {
            console.log(res.result, "邮箱列表cc");
            const list = res.result || [];
            tableData.value = list;
            emailList.value = list.map((item) => ({
              label: item.username,
              value: item.id,
            }));
            console.log(emailList.value, 'emailList')
          })
    }

    const goToAddShowConfig = async () => {
      dialogVisibleEmailBind.value = false;
      setTimeout(() => {
        isFirstShow.value = false
      }, 300)
      // localStorage.setItem('activeMenu', '/email/account_setting')
      router.push({path: `/email/account_setting`, query: {type: 'add'}})
    }

    const cancelConfig = async () => {
      dialogVisibleEmailBind.value = false
      setTimeout(() => {
        isFirstShow.value = false
      }, 300)
    }

    const SideTab = ref(null)
    const isClose = computed(() => store.state.email.isClose)
    const teamFlag = ref(null)
    const addTeam = ref(null)
    // 监听 isClose 变化，动态修改 SideTab 样式
    watch(() => isClose.value, (newVal) => {
      console.log(teamFlag.value, 'teamFlag.value')
      if (SideTab.value && teamFlag.value && teamFlag.value.length > 0 && addTeam.value) {
        SideTab.value.style.width = newVal ? "15px" : "86px";
        SideTab.value.style.minWidth = newVal ? "15px" : "86px";
        SideTab.value.style.overflow = newVal ? "hidden" : "visible";
        addTeam.value.style.display = newVal ? "none" : "inherit"
        teamFlag.value.map(item => {
          item.style.position = newVal ? "absolute" : "static";
          item.style.left = newVal ? "20px" : "0px"
        })
      }
      store.commit("email/setIsClose", newVal)
    });

    const handleClickSide = () => {
      store.commit("email/setIsClose", !isClose.value)
    }


    const isFirstShow = ref(false)
    const changeTabIndex = (val) => {
      visitable.value = false
      tabIndex.value = val
      //  创建团队成功，提示用户是否要进行 去绑定？
      isFirstShow.value = true
    }

    const syncTabIndexWithTeamId = () => {
      const curTeamId = teamId.value === null || teamId.value === undefined ? '' : String(teamId.value)
      if (!curTeamId) return;
      if (!Array.isArray(teamList.value) || teamList.value.length === 0) return;

      const idx = teamList.value.findIndex(t => String(t?.id) === curTeamId)
      if (idx >= 0 && tabIndex.value !== idx) {
        tabIndex.value = idx
        sessionStore.set('tabIndex', idx)
      }
    }

    watch(() => isFirstShow.value, (newVal) => {
      if (newVal) {
        dialogVisibleEmailBind.value = true
        visitable.value = false
      }
    })

    onMounted(async () => {
      await store.dispatch("cloud/queryByUserIdApis");
      tabIndex.value = getTabIndex.value;
      sessionStore.set('tabIndex', getTabIndex.value);
      // await checkTabIndex()
      if (route.query.teamID) {
        await getList()
      }
      syncTabIndexWithTeamId()
      syncShouldShowSideBar()
    });

    watch(
      [() => teamId.value, () => teamList.value],
      () => syncTabIndexWithTeamId(),
      {immediate: true, deep: true}
    )

    watch(
        [() => route.fullPath, () => teamId.value, () => teamList.value],
        () => syncShouldShowSideBar(),
        {immediate: true, deep: true}
    );

    // const checkTabIndex = async () => {
    //   const targetItemTeam = teamList.value[tabIndex.value]
    //   console.log(targetItemTeam, 'targetItemTeam')
    //   if (targetItemTeam) {
    //     // -------------------------------
    //     // ④ 计算跳转路由
    //     // -------------------------------
    //     const targetRoute = computeEmailRoute(targetItemTeam);
    //     // -------------------------------
    //     // ⑤ 避免多次跳转，把路由 push 放在这里统一处理
    //     // -------------------------------
    //     try {
    //       if (targetRoute) {
    //         await router.push(targetRoute);
    //       }
    //     } catch (e) {
    //       console.warn("Navigation warning: ", e);
    //     }
    //   }
    // }

    // const handleClickSelect = () => {
    //   checkTabIndex()
    // }

    return {
      cancelConfig,
      isFirstShow,
      // handleClickSelect,
      changeTabIndex,
      shouldShowSideBar,
      addTeam,
      teamFlag,
      isClose,
      handleClickSide,
      SideTab,
      isRouterAlive,
      teamList,
      tabIndex,
      isEnterpriseChildUser,
      visitableSliderNav,
      tabChange,
      close,
      visitable,
      dialogVisibleTips,
      mailWorkPosition,
      teamId,
      userInfo,
      dialogVisibleEmailBind,
      goToAddShowConfig,
      toBuy,
      closePositionDia
    };
  }
};
</script>
<style lang="less" scoped>
.tab_item {
  transition: all .2s;
  text-align: center;
  line-height: 32px;
  font-size: 14px;
  font-weight: 500;
  width: 76px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.tab_item_sp {
  position: absolute;
  left: 20px;
  transition: all .3s;
  text-align: center;
  line-height: 32px;
  width: 76px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.view {
  flex-grow: 1;
  height: calc(100vh - 48px);
  overflow: hidden scroll;
  //overflow: hidden;
  background-color: rgb(245, 245, 245);
}

.email {
  // width: 100vw;
  // height: 100vh;
  display: flex;
  overflow: hidden;
}

.flex1 {
  flex: 1;
}

.fx-aj-c {
  align-items: center;
  justify-content: center;
}

.fx {
  display: flex;
}

.pointer {
  cursor: pointer;
  transition: all 0.4s;
}

.rlt {
  position: relative;
}

.scroll {
  overflow: auto;
}

.SideTab_sp {
  position: relative;
  z-index: 20;
  width: 15px;
  min-width: 15px;
  //height: calc(100vh - 64px);
  background: #f0f0f0;
  padding: 20px 0 20px 10px;
  overflow: hidden;
  transition: all .3s ease-in-out;

  .menu {
    position: absolute;
    left: 50%;
    transform: translate(-50%, -50%);
    bottom: 15px;
    cursor: pointer;
  }

  .opt {
    width: 100%;
    height: 32px;
    background: #ffffff;
    border-radius: 100px 0px 0px 100px;
    font-weight: 600;
    color: var(--el-text-color-regular);
    font-size: 14px;
    opacity: 0.4;
    margin-bottom: 20px;
    white-space: nowrap;

    &.s {
      opacity: 1;
      color: #fff;
    }
  }
}

.SideTab {
  position: relative;
  z-index: 20;
  width: 86px;
  min-width: 86px;
  height: calc(100vh - 48px);
  background: #f0f0f0;
  //overflow: hidden scroll;
  padding: 20px 0 20px 10px;
  transition: all .3s ease-in-out;

  .menu {
    position: absolute;
    left: 50%;
    transform: translate(-50%, -50%);
    bottom: 15px;
    cursor: pointer;
  }

  .opt {
    width: 100%;
    height: 32px;
    background: #ffffff;
    border-radius: 100px 0px 0px 100px;
    font-weight: 600;
    color: var(--el-text-color-regular);
    font-size: 14px;
    opacity: 0.4;
    margin-bottom: 20px;
    white-space: nowrap;

    &.s {
      opacity: 1;
      color: #fff;
    }
  }
}

.inners_warning {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.setting_center {
  display: flex;
  justify-content: center;
}

.setting_left {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}

.cont {
  display: flex;

  .text {
    display: block;
    overflow: hidden;
    color: rgba(0, 0, 0, .85);
    font-weight: normal;
    font-size: 13px;
    line-height: 1.4;
  }
}

.tab_name {
  padding-left: 4px;
  width: 72px;
  text-overflow: ellipsis;
  overflow: hidden;
  font-size: 13px !important;
}

.SideTab {
  position: relative;
}

.show {
  display: inherit;
}

.hide {
  display: none;
}
</style>
